var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragdropwords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M322.043 102.655h-48.542v136.457h135.844v-49.155h.047c0-3.205 1.116-6.426 3.392-9.027 4.986-5.698 13.647-6.275 19.344-1.29l75.107 65.97c.481.417.941.869 1.373 1.363 4.985 5.697 4.408 14.358-1.29 19.344l-74.334 65.291a13.714 13.714 0 01-9.883 4.191c-7.595 0-13.756-6.161-13.756-13.756v-48.542H273.501v135.844h48.542c7.595 0 13.756 6.161 13.756 13.756 0 3.878-1.607 7.382-4.191 9.883l-65.291 74.334c-4.986 5.698-13.647 6.275-19.344 1.29a14.008 14.008 0 01-1.363-1.373l-65.97-75.107c-4.985-5.697-4.408-14.358 1.29-19.344a13.665 13.665 0 019.027-3.392v-.047h49.155V273.501H102.655v48.542h-.047c0 3.205-1.116 6.426-3.392 9.027-4.986 5.698-13.647 6.275-19.344 1.29L4.765 266.39a14.008 14.008 0 01-1.373-1.363c-4.985-5.697-4.408-14.358 1.29-19.344l74.334-65.291a13.714 13.714 0 019.883-4.191c7.595 0 13.756 6.161 13.756 13.756v49.155h136.457V102.655h-49.155v-.047a13.665 13.665 0 01-9.027-3.392c-5.698-4.986-6.275-13.647-1.29-19.344l65.97-75.107c.417-.481.869-.941 1.363-1.373 5.697-4.985 14.358-4.408 19.344 1.29l65.291 74.334a13.714 13.714 0 014.191 9.883c0 7.595-6.161 13.756-13.756 13.756z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdropwords);
export default __webpack_public_path__ + "static/media/drag&dropwords.7ec76e88bf1d59d04ed16ba8e8cbc7ab.svg";
export { ForwardRef as ReactComponent };